import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const tooltip = (
  <Tooltip id="ttlTip">
    <strong>Time To Live</strong>
    <br />
    Remaining time for this override
  </Tooltip>
);

export const AdminHeader = function (props) {
  //todo change the return based on type
  return (
    <tr>
      <th>User ID</th>
      <th>Subdivision</th>
      <th>Start MP/Suffix</th>
      <th>End MP/Suffix</th>
      <th>Minutes</th>
      <th>Reason</th>
      <th>Granted by</th>
      <th>Granted at</th>
      <th>Expire at</th>
      <th>
        TTL{" "}
        <OverlayTrigger placement="top" overlay={tooltip}>
          <span className="glyphicon glyphicon-question-sign"></span>
        </OverlayTrigger>
      </th>
    </tr>
  );
};
